// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"2d39bdbc","453":"ff8f0327"}[chunkId] + ".chunk.js";
};